<template>
  <div 
    class="flex w-full"
    @click="open"
  >
    <button
      type="button"
      :disabled="disabled"
      class="inline-flex items-center px-5 py-2.5 text-sm font-medium border border-tuin-100 rounded-l-lg text-tuin-100 bg-white hover:bg-tuin_hover hover:text-white transition-colors cursor-pointer"
    >
      {{ buttonText }}
    </button>

    <div
      class="flex-1 border border-l-0 rounded-r-lg px-5 py-2.5 text-sm font-normal border-gray-300 text-gray-500 truncate"
    >
      {{ filename }}
    </div>

    <input
      ref="input"
      type="file"
      class="hidden"
      :accept="accept"
      :multiple="multiple"
      @change="onChange"
    >
  </div>
</template>
<script setup>
import { computed, ref } from 'vue'

const props = defineProps({
  modelValue: {
    type: [File, Array, null],
    default: null
  },
  accept: {
    type: String,
    default: ''
  },
  multiple: Boolean,
  buttonText: {
    type: String,
    default: 'Seleccionar archivo'
  },
  placeholder: {
    type: String,
    default: 'Sin archivos seleccionados'
  },
  disabled: Boolean
})

const emit = defineEmits([
  'update:modelValue',
  'change'
])

const input = ref(null)

const filename = computed(() => {
  if (!props.modelValue)
    return props.placeholder

  if (Array.isArray(props.modelValue))
    return props.modelValue.map(f => f.name).join(', ')

  return props.modelValue.name
})

const open = () => {
  if (!props.disabled)
    input.value.click()
}

const onChange = (e) => {
  const files = [...e.target.files]

  const value = props.multiple
    ? files
    : files[0] ?? null

  emit('update:modelValue', value)
  emit('change', value)
}
</script>